var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemporalPartnerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 449,
    height: 134,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.75 2.1875 2.75 2.1875 5 5 C5.97646484 6.0828125 5.97646484 6.0828125 6.97265625 7.1875 C9.38479147 10.53381475 10.54378948 13.90329009 11.6875 17.8125 C12.00557617 18.82280273 12.00557617 18.82280273 12.33007812 19.85351562 C13.75701659 24.55746105 14.50177143 29.11079001 15 34 C15.87398437 34.03867188 15.87398437 34.03867188 16.765625 34.078125 C27.74696955 34.83784066 38.86938464 38.06714642 46.9375 45.875 C48.51343939 49.02687877 48.9391752 51.4721614 49 55 C45.96589491 61.59588064 40.63641399 64.50736726 34.1640625 67.1640625 C27.79502746 69.43988736 21.75421779 70.70114081 15 71 C14.82984375 72.05058594 14.6596875 73.10117188 14.484375 74.18359375 C12.5404666 85.66373401 9.95300585 95.09263345 2 104 C-1.22637379 105.61318689 -4.51093124 105.5860019 -8 105 C-10.6875 102.9375 -10.6875 102.9375 -13 100 C-14.2684375 98.5459375 -14.2684375 98.5459375 -15.5625 97.0625 C-20.64458216 89.75199696 -22.30066451 79.74169361 -23 71 C-23.58265625 70.97421875 -24.1653125 70.9484375 -24.765625 70.921875 C-36.45272182 70.11333371 -47.64057143 66.57696016 -56 58 C-57.57021962 54.53295507 -57.59915583 51.61866183 -56.25390625 47.984375 C-51.46659096 40.40818756 -41.28454033 36.97354233 -33 35 C-29.66666625 34.48516573 -26.36892422 34.14906744 -23 34 C-22.90203125 33.18917969 -22.8040625 32.37835938 -22.703125 31.54296875 C-21.09344278 19.62299435 -18.42078986 9.91857054 -10 1 C-6.77783103 -0.61108448 -3.48459429 -0.59755085 0 0 Z M-8.69921875 9.0234375 C-13.57443203 16.43141925 -15.0340208 24.3061872 -16 33 C-8.08 33 -0.16 33 8 33 C6.85945869 23.87566953 5.20654127 14.17631335 -1 7 C-4.32699562 4.96087365 -6.20027792 6.25371361 -8.69921875 9.0234375 Z M-17 39 C-20.13787049 57.00871608 -18.31036226 80.85283818 -8.34375 96.64453125 C-6.61842745 98.38490021 -5.4268769 98.77248029 -3 99 C5.73696655 92.66569925 7.39298724 79.97078375 9 70 C9.04460695 68.33393037 9.06249511 66.66549456 9 65 C10.010625 65.0825 11.02125 65.165 12.0625 65.25 C22.6320797 65.23115939 34.46977688 61.53022312 42 54 C41.90394769 51.11843064 41.06869038 50.0709062 39.0625 48 C22.44031389 37.14469478 1.96935204 38.5940492 -17 39 Z M-49 49 C-49.77666451 51.58241831 -49.77666451 51.58241831 -50 54 C-42.32439181 61.27162881 -34.33267306 62.93346539 -24 65 C-24 56.75 -24 48.5 -24 40 C-31.41831084 40 -43.64832454 43.98789786 -49 49 Z ",
    fill: "#131313",
    transform: "translate(70,13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.66 0.66 7.32 1.32 8 2 C8.99 1.34 9.98 0.68 11 0 C15.59602013 -0.75287187 19.63424645 -0.63754167 23.5625 2 C24.366875 2.66 25.17125 3.32 26 4 C26.99 3.34 27.98 2.68 29 2 C33.06011935 -0.29200286 36.41177918 -0.89065463 41 0 C44.56679761 1.30782579 47.36937161 2.78884473 49.18310547 6.2722168 C50.09260166 9.30921649 50.22779572 11.78991706 50.1953125 14.95703125 C50.18886719 16.06884766 50.18242187 17.18066406 50.17578125 18.32617188 C50.15902344 19.47666016 50.14226562 20.62714844 50.125 21.8125 C50.11597656 22.98232422 50.10695313 24.15214844 50.09765625 25.35742188 C50.07413732 28.23849053 50.04126852 31.11913989 50 34 C48.02 34 46.04 34 44 34 C43.970271 33.03175293 43.970271 33.03175293 43.93994141 32.04394531 C43.84453672 29.11222779 43.73492029 26.18120768 43.625 23.25 C43.5940625 22.23421875 43.563125 21.2184375 43.53125 20.171875 C43.47324219 18.70234375 43.47324219 18.70234375 43.4140625 17.203125 C43.3826416 16.30239258 43.3512207 15.40166016 43.31884766 14.47363281 C42.97988044 11.84391168 42.4934188 10.18936304 41 8 C37.63239813 6.8283633 37.63239813 6.8283633 34 7 C30.75684733 9.30434532 29.74376351 11.19477909 29 15 C28.85870882 16.51270605 28.75537183 18.02928128 28.68359375 19.546875 C28.64169922 20.39121094 28.59980469 21.23554687 28.55664062 22.10546875 C28.51732422 22.97816406 28.47800781 23.85085937 28.4375 24.75 C28.39431641 25.63816406 28.35113281 26.52632812 28.30664062 27.44140625 C28.20086385 29.62745963 28.09877454 31.81362089 28 34 C26.02 34 24.04 34 22 34 C21.98541748 33.32420898 21.97083496 32.64841797 21.95581055 31.95214844 C21.88124589 28.88419478 21.78461345 25.81731924 21.6875 22.75 C21.66494141 21.68652344 21.64238281 20.62304688 21.61914062 19.52734375 C21.5659668 17.99013672 21.5659668 17.99013672 21.51171875 16.421875 C21.48553467 15.47924805 21.45935059 14.53662109 21.43237305 13.56542969 C20.9280003 10.57279909 20.11517727 9.15728742 18 7 C15 6.41666667 15 6.41666667 12 7 C9.96332385 8.54506466 9.13926922 9.72146156 8 12 C7.84777027 13.66565749 7.75082785 15.33656496 7.68359375 17.0078125 C7.64169922 17.99394531 7.59980469 18.98007813 7.55664062 19.99609375 C7.51732422 21.02863281 7.47800781 22.06117187 7.4375 23.125 C7.39431641 24.16527344 7.35113281 25.20554687 7.30664062 26.27734375 C7.2003712 28.85142528 7.09833417 31.42560508 7 34 C4.69 34 2.38 34 0 34 C0 22.78 0 11.56 0 0 Z ",
    fill: "#131313",
    transform: "translate(222,55)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.66 0.99 7.32 1.98 8 3 C8.66 2.505 9.32 2.01 10 1.5 C13.74809414 -0.37404707 16.92266891 -0.58476458 21 0 C26.77405689 2.10975155 29.64438008 5.22420684 32.3125 10.6875 C33.54947383 16.64746484 33.03931507 21.92136986 30.3125 27.375 C27.11093658 31.00920713 24.51501444 33.68164374 19.53125 34.3125 C14.80291455 34.42375495 12.34426929 34.17213464 8 32 C7.67 36.95 7.34 41.9 7 47 C4.69 47 2.38 47 0 47 C0 31.49 0 15.98 0 0 Z M7 11 C5.79356434 14.61930698 5.67731441 17.19231005 6 21 C8.2587937 25.24028619 8.2587937 25.24028619 12 28 C15.05940837 28.42074378 17.9459708 28.47999423 21 28 C24.28175318 25.47031526 25.69243777 23.92268669 27 20 C27.3686858 15.02274174 27.16456308 11.95570385 24 8 C21.01200835 5.67600649 17.70284602 5.52577584 13.96875 5.609375 C10.57872325 6.28199936 9.03151758 8.35287104 7 11 Z ",
    fill: "#131313",
    transform: "translate(280,55)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.9323173 2.65202795 6.18648186 5.30944559 7.6875 9.8125 C7.6875 12.4525 7.6875 15.0925 7.6875 17.8125 C-0.5625 17.8125 -8.8125 17.8125 -17.3125 17.8125 C-14.97401858 23.72981018 -14.97401858 23.72981018 -11.3125 25.8125 C-7.71677296 26.37070763 -4.39790519 26.58278755 -1.375 24.4375 C-0.25326516 22.79000576 -0.25326516 22.79000576 0.6875 20.8125 C2.9975 20.8125 5.3075 20.8125 7.6875 20.8125 C7.27193583 25.66074868 5.31301755 27.69286862 1.6875 30.8125 C-2.81330463 33.52996695 -7.19612796 33.33061362 -12.3125 32.8125 C-18.1031623 30.77504475 -20.96404528 27.57362158 -23.625 22.125 C-24.87455656 16.10440928 -24.37470115 10.82701943 -21.5 5.375 C-15.65875175 -1.4676051 -8.44516631 -3.02751245 0 0 Z M-16.3125 8.8125 C-16.3125 9.8025 -16.3125 10.7925 -16.3125 11.8125 C-10.7025 11.8125 -5.0925 11.8125 0.6875 11.8125 C0.0585612 7.92992778 0.0585612 7.92992778 -1.9375 6.0625 C-7.54179814 3.1128694 -12.09396699 4.33829832 -16.3125 8.8125 Z ",
    fill: "#141414",
    transform: "translate(206.3125,56.1875)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.17686383 2.05179276 6.26222898 3.73571002 8 8 C8.31884766 10.19824219 8.31884766 10.19824219 8.4140625 12.546875 C8.45273437 13.39121094 8.49140625 14.23554687 8.53125 15.10546875 C8.5621875 15.97816406 8.593125 16.85085937 8.625 17.75 C8.66367187 18.63816406 8.70234375 19.52632812 8.7421875 20.44140625 C8.83620873 22.6273998 8.92186143 24.81339062 9 27 C9.99 27.33 10.98 27.66 12 28 C12 29.98 12 31.96 12 34 C5.6 34.36923077 5.6 34.36923077 2.5625 32.5 C2.046875 32.005 1.53125 31.51 1 31 C0.17822266 31.73089844 0.17822266 31.73089844 -0.66015625 32.4765625 C-4.76293816 35.14782284 -9.27154673 34.51213218 -14 34 C-17.38622921 32.68697235 -18.50297755 31.81330947 -20.375 28.75 C-21.19780531 25.12965664 -20.91464645 22.59325392 -20 19 C-18.10888889 16.6818638 -16.66171969 15.33085985 -14 14 C-11.28239892 13.92818179 -8.59140612 13.90700494 -5.875 13.9375 C-5.12089844 13.94201172 -4.36679687 13.94652344 -3.58984375 13.95117188 C-1.72652873 13.96296501 0.13674555 13.98090058 2 14 C1.39816251 11.97954558 0.72693904 9.97888961 0 8 C-3.09173752 6.45413124 -5.59429552 6.70640479 -9 7 C-9.66 7.66 -10.32 8.32 -11 9 C-13 11 -13 11 -16.75 11.25 C-17.8225 11.1675 -18.895 11.085 -20 11 C-18.75892597 6.03570389 -17.23893588 3.86128172 -13 1 C-9.05322303 -0.97338848 -4.30160477 -0.44290148 0 0 Z M-14 21 C-14.66685938 23.45672892 -14.66685938 23.45672892 -14 26 C-12.05649286 28.15163476 -12.05649286 28.15163476 -9 29 C-6.04460438 28.91950284 -3.62605115 28.36986651 -1 27 C0.84953941 24.22569089 2 22.35957737 2 19 C-0.10388569 18.94597726 -2.20816714 18.90719744 -4.3125 18.875 C-5.48425781 18.85179688 -6.65601563 18.82859375 -7.86328125 18.8046875 C-11.16393661 18.74679382 -11.16393661 18.74679382 -14 21 Z ",
    fill: "#131313",
    transform: "translate(402,55)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.72675346 1.85936947 6.42615736 4.41754028 8.27734375 8.16015625 C9.93535747 13.61209548 10.03386768 19.4336187 8.0234375 24.7890625 C5.50047611 29.21445109 2.93263343 31.86486787 -2.05859375 33.34375 C-7.214934 33.96001457 -12.23337303 34.15325897 -16.99609375 31.84375 C-21.49918844 28.16775433 -23.66819095 24.5905176 -24.3671875 18.77734375 C-24.48226423 14.23519765 -24.2393837 10.43273115 -22.05859375 6.34375 C-21.39859375 6.34375 -20.73859375 6.34375 -20.05859375 6.34375 C-19.85234375 5.745625 -19.64609375 5.1475 -19.43359375 4.53125 C-15.41917056 -1.85533234 -6.60698432 -2.10621132 0 0 Z M-16.05859375 9.34375 C-18.53460707 13.50795421 -18.21643017 16.71240432 -17.05859375 21.34375 C-15.23520323 24.04942626 -13.98401939 25.88103718 -11.05859375 27.34375 C-5.20316422 27.94866525 -5.20316422 27.94866525 -0.12109375 25.34375 C2.42900442 21.6345163 3.24901735 18.82608324 2.94140625 14.34375 C1.47035359 10.24028731 -0.09674705 7.32467335 -4.05859375 5.34375 C-9.51291765 4.64956332 -12.26112701 5.32928516 -16.05859375 9.34375 Z ",
    fill: "#131313",
    transform: "translate(343.05859375,55.65625)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.55 0 23.1 0 35 0 C35 1.98 35 3.96 35 6 C30.38 6 25.76 6 21 6 C21 19.2 21 32.4 21 46 C18.69 46 16.38 46 14 46 C14 33.13 14 20.26 14 7 C7.07 6.505 7.07 6.505 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#141414",
    transform: "translate(147,43)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 0.99 6.66 1.98 7 3 C7.886875 2.505 8.77375 2.01 9.6875 1.5 C12.87586238 0.05621326 14.58187546 -0.30159922 18 0 C18 2.31 18 4.62 18 7 C16.906875 7.0825 15.81375 7.165 14.6875 7.25 C11.02500718 7.65073293 11.02500718 7.65073293 9.125 9.8125 C7.35489191 13.25437685 6.87550142 16.48997164 6.68359375 20.328125 C6.64169922 21.12734375 6.59980469 21.9265625 6.55664062 22.75 C6.49766602 23.9875 6.49766602 23.9875 6.4375 25.25 C6.39431641 26.09046875 6.35113281 26.9309375 6.30664062 27.796875 C6.20091457 29.86440671 6.09998705 31.93218281 6 34 C4.02 34 2.04 34 0 34 C0 22.78 0 11.56 0 0 Z ",
    fill: "#141414",
    transform: "translate(359,55)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 15.18 6 30.36 6 46 C4.02 46 2.04 46 0 46 C0 30.82 0 15.64 0 0 Z ",
    fill: "#141414",
    transform: "translate(420,43)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(65,110)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#000000",
    transform: "translate(65,20)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#000000",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemporalPartnerLogo);
export default __webpack_public_path__ + "static/media/temporal-partner-logo.616e6f8118171668ea0caac90c6b106d.svg";
export { ForwardRef as ReactComponent };